import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuthToken } from "jwt-storage-lib";

export type Attachment = {
    _id: string;
    url: string;
    name: string;
    originalUrl?: string;
};

export const attachmentsApi = createApi({
    reducerPath: "attachmentsApi",
    baseQuery: fetchBaseQuery({
        baseUrl: import.meta.env.VITE_HUB_API,
        prepareHeaders: async headers => {
            const token = await getAuthToken();
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        }
    }),
    tagTypes: ["attachments"],
    endpoints: builder => ({
        uploadAttachments: builder.mutation<Attachment[], { companyId: string; accountId?: string; files: File[] }>({
            query: ({ companyId, accountId, files }) => {
                const formData = new FormData();
                formData.append("companyId", companyId);
                if (accountId) formData.append("accountId", accountId);
                files.forEach(file => formData.append("files", file));
                return {
                    url: `attachments/${companyId}`,
                    method: "POST",
                    body: formData
                };
            }
        })
    })
});

export const { useUploadAttachmentsMutation } = attachmentsApi;
